import { useSelector } from "react-redux";
import { useRole } from "./use-role";

export const AUTH_LEVEL = {
    READ_ONLY: 1,
    WRITE: 2,
    FULL_ACCESS: 3,
};

export const normalizePermission = (permissionValue) => {
    if (!permissionValue || Array.isArray(permissionValue) || typeof permissionValue !== "object") {
        return {};
    }

    return permissionValue;
};

export const useAuth = (code, level = AUTH_LEVEL.READ_ONLY) => {
    const role = useRole();
    const permission = useSelector((state) => state.Auth.permission);
    const normalizedPermission = normalizePermission(permission);

    return role === 1 || (normalizedPermission[code] || 0) >= level;
};

export const useAuthReadOnly = (code) => {
    return useAuth(code, AUTH_LEVEL.READ_ONLY);
};

export const useAuthEditable = (code) => {
    return useAuth(code, AUTH_LEVEL.WRITE);
};

export const useAuthFullAccess = (code) => {
    return useAuth(code, AUTH_LEVEL.FULL_ACCESS);
};
